// extracted by mini-css-extract-plugin
export var card = "styles-module--card--vBu+i";
export var cardMemberInfo = "styles-module--cardMemberInfo--jtToJ";